module.exports = __webpack_public_path__ + "static/media/landing-bg.0d24bc8a.jpg";